module.exports = __webpack_public_path__ + "static/img/lizhong.781e53ba.png";